import { useState } from "react";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Typography,
} from "@mui/material";
import { Box, fontWeight } from "@mui/system";
import { AuthActionButton } from "../../common/StyledComponents/AuthComponents";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import RecommendedBox from "../../common/RecommendedBox";
import { fontSizeSchemes } from "../../assets/commonFunction";
import warningIcon from '../../assets/images/auth/warningIcon.svg'


const classes = {
  signInBox: {
    padding: "1rem 1rem 2rem 2rem",
    border: "1px solid #C4C4C4",
    height: "calc(100vh - 32px)",
    maxHeight: "700px",
    width: "100%",
    maxWidth: "690px",
    margin: "auto",
    position: "relative",
    "@media only screen and (max-width:900px)": {
      margin: "auto !important",
      padding: "1.5rem 2rem 2rem 2rem !important",
    },
    "@media only screen and (max-width:1024px)": {
      height: "100%",
      padding: "1rem",
      marginLeft: "-20px",
    },
    "@media only screen and (max-width:1300px)": {
      minHeight: "530px",
    },
  },
  content: {
    // paddingLeft: "29px",
    fontSize: fontSizeSchemes.font16,
    color: "#000000",
    fontWeight:400
  },
  nexBtn: {
    position: "absolute",
    bottom: "2rem",
    left: "50%",
    marginLeft: "-2.72rem",
    "@media only screen and (max-width:899px)": {
      position: "relative",
      marginBottom: "-1.8rem",
      bottom: "0 !important",
    },
    "@media only screen and (max-width:1300px)": {
      bottom: "1.5rem",
    },
  },
};

const UpdateProfile = () => {
  const [isIndividualChecked, setIndividualChecked] = useState(false);
  const [isOrganizationChecked, setOrganizationChecked] = useState(false);
  const { t } = useTranslation();
  const appContent = t("AppContent", {
    returnObjects: true,
  });
  const navigate = useNavigate();
  const handleIndividualChange = (event) => {
    if (event.target.checked) {
      setIndividualChecked(true);
      setOrganizationChecked(false);
    }
  };

  const handleOrganizationChange = (event) => {
    if (event.target.checked) {
      setIndividualChecked(false);
      setOrganizationChecked(true);
    }
  };
  const handleClick = () => {
    if (isIndividualChecked || isOrganizationChecked) {
      if (isIndividualChecked) {
        navigate("/individualprofile");
      }
      if (isOrganizationChecked) {
        navigate("/organisationprofile");
      }
    }
  };

  return (
    <Box sx={classes.signInBox}>
      <Typography
        fontSize={fontSizeSchemes.font28}
        fontWeight={600}
        variant="h5"
        mb={"0.4rem"}
      >
        {appContent?.KEY37}
      </Typography>
      <Box mt={"2rem"}>
        <Typography fontSize={fontSizeSchemes.font18} fontWeight={700} variant="h5">
          {appContent?.KEY274}
        </Typography>
      </Box>
      <Box mt={"0.8rem"}>
        <Typography fontSize={fontSizeSchemes.font16} fontWeight={600} variant="h5">
          ({appContent?.KEY275})
        </Typography>
      </Box>

      <FormGroup sx={{ mt: "1rem" }}>
        <Box mb={"1rem"}>
          <FormControlLabel
            required
            sx={{
              ".MuiFormControlLabel-label": {
              },
            }}
            control={
              <Checkbox
                style={{ color: "#183243" }}
                checked={isIndividualChecked}
                onChange={handleIndividualChange}
              />
            }
            label={<Typography fontSize={fontSizeSchemes.font18} fontWeight={700} variant="h5">{appContent?.KEY276}</Typography>}
            labelPlacement="end"
          />
          <FormHelperText sx={classes.content}>
            {appContent?.KEY278}
          </FormHelperText>
        </Box>

        <Box>
          <FormControlLabel
            required
            sx={{
              ".MuiFormControlLabel-label": {
                fontSize: fontSizeSchemes.font18,
                fontWeight: 700,
              },
            }}
            control={
              <Checkbox
                checked={isOrganizationChecked}
                onChange={handleOrganizationChange}
                sx={{ "& .MuiSvgIcon-root": { color: "#183243" } }}
              />
            }
            label={<Typography fontSize={fontSizeSchemes.font18} fontWeight={700} variant="h5">{appContent?.KEY277}</Typography>}
            labelPlacement="end"
          />
          <FormHelperText sx={classes.content}>
            {appContent?.KEY279}
          </FormHelperText>
          <Box sx={{ marginTop: "1rem" }}>
            <RecommendedBox content={appContent?.KEY281} />
          </Box>
        </Box>

        <Box mt={"1.4rem"} display={"flex"} flexDirection={"row"} 
        alignItems={"center"} justifyContent={"center"} gap={"0.4rem"}>
          <img src={warningIcon} alt="warning" style={{ alignSelf:'flex-start', marginTop:'0.4rem', width: "12px", height: "13px" }} />
          <FormHelperText sx={{ ...classes.content, color: "red",fontSize:fontSizeSchemes.font12 }}>
            {appContent?.KEY280}
          </FormHelperText>
        </Box>
        <Box sx={classes.nexBtn}>
          <AuthActionButton
            onClick={handleClick}
            type="submit"
            variant="contained"
            disabled={
              isOrganizationChecked || isIndividualChecked ? false : true
            }
          >
            Next
          </AuthActionButton>
        </Box>
      </FormGroup>
    </Box>
  );
};

export default UpdateProfile;
